import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  html {
  }

  body {
     text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale;
  }

  body, #root {
    background: ${({ theme }) => theme.colors.BG1};
    color: ${({ theme }) => theme.colors.TEXT1};
    height: 100%;
    width: 100%;
    position: fixed;
  }

  body {
    scrollbar-color: ${({ theme }) =>
      `${theme.colors.BAR1} ${theme.colors.BAR2}`};
    scrollbar-width: thin; 
  }

  body::-webkit-scrollbar {
    width: 12px; 
    height: 12px; 
  }

  body::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.BAR1};
  }

  body::-webkit-scrollbar-thumb {
    background-color:${({ theme }) => theme.colors.BAR1}; 
    border-radius: 20px;
    border: ${({ theme }) => `3px solid ${theme.colors.BAR2}`}; 
  }

  body::-webkit-scrollbar-thumb:hover {
    background:${({ theme }) => theme.colors.BAR3}; 
  }

  #root {
    height: 100%;
  }


  * {
    font-family: 'Sora', sans-serif;
  }

  body, input, textarea, button {
    font-family: 'Sora', sans-serif;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  a {
    text-decoration: none;
    background: none;
    font-weight: 700;
    cursor: pointer;
    border: 0;
    transition: 180ms ease-in-out;
  }

  button {
    cursor: pointer;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ul {
    list-style: none;
    text-align: left;
    padding: 0;
  }

  .swal-overlay {
    background: ${({ theme }) => theme.colors.LIGHT2};
  }

  .swal-modal {
    border-radius: 2px;
    background :rgba(0,0,0,0);
    box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
    border: 1px solid rgba(255,255,255,0);
    border-radius: 5px;
    margin-top: -100px;
    width: 600px;
    padding: 20px 0;

    @media (max-width: 1024px) {  
      width: 100%;
    }



  }
  
  .swal-title {
    color: rgba(255, 255, 255, 0.8);
    font-size: 32px;
    font-weight: normal;
  }

  .swal-title:not(:last-child) {
    margin-bottom: 0px;
  }

  .swal-text {
    color: rgba(255, 255, 255, 0.4);
    font-size: 22px;
    font-weight: normal;
  }

  .swal-button {
    padding: 20px 40px 20px 40px;
    border-radius: 0px;
    font-weight: normal;
    font-size: 12px;
    transition: all 0.5s ease;
    border: none !important;
    border-radius: 6px;
  }

  .swal-footer {
    text-align: center;
  }

  .swal-icon--success:after,
  .swal-icon--success:before,
  .swal-icon--success__hide-corners {
    background: ${({ theme }) => theme.colors.LIGHT2};
  }

  .swal-button.swal-button--cancel , 
  .swal-button.swal-button--confirm {
    background: #fff;
    font-size: 18px;
    font-weight: 700;
    color: #2b353f;
    border: none;
    
    &:hover {
      background: #333;
      color: ${({ theme }) => theme.colors.TEXT1};
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    color: #333 !important;
  }


  /*

Atom One Dark by Daniel Gamage
Original One Dark Syntax theme from https://github.com/atom/one-dark-syntax

base:    #282c34
mono-1:  #abb2bf
mono-2:  #818896
mono-3:  #5c6370
hue-1:   #56b6c2
hue-2:   #61aeee
hue-3:   #c678dd
hue-4:   #98c379
hue-5:   #e06c75
hue-5-2: #be5046
hue-6:   #d19a66
hue-6-2: #e6c07b

*/

.hljs {
  display: block;
  overflow-x: auto;
  padding: 0.5em;
  color: #abb2bf;
  background: #282c34;
}

.hljs-comment,
.hljs-quote {
  color: #5c6370;
  font-style: italic;
}

.hljs-doctag,
.hljs-keyword,
.hljs-formula {
  color: #c678dd;
}

.hljs-section,
.hljs-name,
.hljs-selector-tag,
.hljs-deletion,
.hljs-subst {
  color: #e06c75;
}

.hljs-literal {
  color: #56b6c2;
}

.hljs-string,
.hljs-regexp,
.hljs-addition,
.hljs-attribute,
.hljs-meta-string {
  color: #98c379;
}

.hljs-built_in,
.hljs-class .hljs-title {
  color: #e6c07b;
}

.hljs-attr,
.hljs-variable,
.hljs-template-variable,
.hljs-type,
.hljs-selector-class,
.hljs-selector-attr,
.hljs-selector-pseudo,
.hljs-number {
  color: #d19a66;
}

.hljs-symbol,
.hljs-bullet,
.hljs-link,
.hljs-meta,
.hljs-selector-id,
.hljs-title {
  color: #61aeee;
}

.hljs-emphasis {
  font-style: italic;
}

.hljs-strong {
  font-weight: bold;
}

.hljs-link {
  text-decoration: underline;
}



  span.alta-prioridade {
    background: rgba(255, 77, 109, 0.12);
    border-color: rgba(255, 77, 109, 0.28);
  }

  span.reposicao {
    background: rgba(255, 176, 32, 0.12);
    border-color: rgba(255, 176, 32, 0.26);
  }

  span.oportunidade {
    background: rgba(88, 166, 255, 0.12);
    border-color: rgba(88, 166, 255, 0.26);
  }

  span.consolidado {
    background: rgba(179, 107, 255, 0.12);
    border-color: rgba(179, 107, 255, 0.26);
  }

  span.classe-a {
    background: rgba(255, 77, 109, 0.12);
    border-color: rgba(255, 77, 109, 0.28);
  }

  span.classe-b {
    background: rgba(255, 176, 32, 0.12);
    border-color: rgba(255, 176, 32, 0.26);
  }

  span.classe-c {
    background: rgba(88, 166, 255, 0.12);
    border-color: rgba(88, 166, 255, 0.26);
  }

  span.classe-n {
    background: rgba(179, 107, 255, 0.12);
    border-color: rgba(179, 107, 255, 0.26);
  }

  span.classe-se {
    background: rgba(68, 255, 146, 0.12);
    border-color: rgba(48, 255, 100, 0.26);
  }

   span.saudável {
    background: rgba(68, 255, 146, 0.12);
    border-color: rgba(48, 255, 100, 0.26);
  }

   span.comprar_urgente {
    background: rgba(255, 176, 32, 0.12);
    border-color: rgba(255, 176, 32, 0.26);
  }
   span.estoque_alto {
    background: rgba(88, 166, 255, 0.12);
    border-color: rgba(88, 166, 255, 0.26);
  }

  span.ruptura_crítica {
    background: rgba(255, 77, 110, 0.16);
    border-color: rgba(255, 77, 110, 0.28);
  }

  span.caindo {
    background: rgba(255, 77, 110, 0.16);
    border-color: rgba(255, 77, 110, 0.28);
  }
  
  span.crescendo {
     background: rgba(68, 255, 146, 0.12);
    border-color: rgba(48, 255, 100, 0.26);
  }

  span.semestoque {
    background: rgba(255,176,32,.12);
    border-color: rgba(255,176,32,.26);
  }

  span.estavel,
  span.estável {
    background: rgba(88, 166, 255, 0.12);
    border-color: rgba(88, 166, 255, 0.26);
  }
 


  span.negativo {
    background: rgba(255, 77, 110, 0.16);
    border-color: rgba(255, 77, 110, 0.28);
  }
  span.positivo {
     background: rgba(68, 255, 146, 0.12);
    border-color: rgba(48, 255, 100, 0.26);
  }

   span.giro-alto,
   span.giro_alto {
     background: rgba(68, 255, 146, 0.12);
    border-color: rgba(48, 255, 100, 0.26);
  }
  
  

`;
